import { type DateType } from '@travelata-libs/utils';
import { type useCalendar } from './composables/useCalendar';

export enum CalendarSize {
  M = 'm',
  L = 'l',
}

export enum MonthName {
  January = 'Январь',
  February = 'Февраль',
  March = 'Март',
  April = 'Апрель',
  May = 'Май',
  June = 'Июнь',
  July = 'Июль',
  August = 'Август',
  September = 'Сентябрь',
  October = 'Октябрь',
  November = 'Ноябрь',
  December = 'Декабрь',
}

export type DateTimestamp = number;
export type DateISO = string;

export interface CalendarDateRange<T = Date> {
  start: T;
  end: T;
}

export type CalendarModelValue<T = DateType> = T | CalendarDateRange<T> | null;
export type CalendarSystemModelValue<T = DateTimestamp> = CalendarDateRange<T> | null;

export type CalendarAPI = ReturnType<typeof useCalendar>;

export interface CalendarEvents {
  onDayClick: ((day: DateTimestamp, calendar: CalendarAPI, span?: number) => void) | null;
  onDayHover: ((day: DateTimestamp, calendar: CalendarAPI, span?: number) => void) | null;
}

export interface DayCell {
  ts: DateTimestamp;
  dayStart: DateTimestamp;
  label: string;
  isOtherMonth: boolean;
  isDisabled: boolean;
}
